import { svg } from "lit";
const icon = svg `<path d="M27.6923 35.2261L26.0615 33.6454L34.6539 25.0531H9V22.7839H34.6539L26.0308 14.1608L27.6614 12.5801L38.9999 23.9185L27.6923 35.2261Z" fill="currentColor"/>`;
export default icon;
